module.exports = __webpack_public_path__ + "img/baa9998.jpg";